import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Ruta from "@/pages/Ruta";
import Formato from "@/pages/Formato";
import Episodios from "@/pages/Episodios";
import AppPage from "@/pages/AppPage";
import AntoBella from "@/pages/AntoBella";
import Believers from "@/pages/Believers";
import VIP from "@/pages/VIP";
import EnVivo from "@/pages/EnVivo";
import Patrocinadores from "@/pages/Patrocinadores";
import Marcas from "@/pages/Marcas";
import OnboardingPage from "@/pages/OnboardingPage";
import Panel from "@/pages/Panel";
import AppPreview from "@/pages/AppPreview";
import OnePagerCasaProductora from "@/pages/OnePagerCasaProductora";
import WebSponsorship from "@/pages/WebSponsorship";
import { SPONSOR_ONBOARDING, BRAND_ONBOARDING } from "@/data/onboarding";
import NotFound from "@/pages/NotFound";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { PassportProvider } from "@/context/PassportContext";
import { BroadcastProvider } from "@/context/BroadcastContext";

function App() {
  return (
    <LanguageProvider>
      <PassportProvider>
        <BroadcastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/panel" element={<Panel />} />
              <Route path="/app-preview" element={<AppPreview />} />
              <Route path="/one-pager-anto-y-bella" element={<OnePagerCasaProductora />} />
              <Route path="/web-sponsorship-anto-y-bella" element={<WebSponsorship />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/la-ruta" element={<Ruta />} />
                <Route path="/el-formato" element={<Formato />} />
                <Route path="/episodios" element={<Episodios />} />
                <Route path="/la-app" element={<AppPage />} />
                <Route path="/anto-bella" element={<AntoBella />} />
                <Route path="/believers" element={<Believers />} />
                <Route path="/vip" element={<VIP />} />
                <Route path="/en-vivo" element={<EnVivo />} />
                <Route path="/patrocinadores" element={<Patrocinadores />} />
                <Route path="/patrocinadores/onboarding" element={<OnboardingPage config={SPONSOR_ONBOARDING} />} />
                <Route path="/marcas" element={<Marcas />} />
                <Route path="/marcas/onboarding" element={<OnboardingPage config={BRAND_ONBOARDING} />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </BroadcastProvider>
      </PassportProvider>
    </LanguageProvider>
  );
}

export default App;
